import React, { useState } from 'react'

export default function BsHead({dataHeader}) {
   const [HeadTable,setHeadTable] =useState(dataHeader);
   return (
  <tr>
   { HeadTable?.map((c,i) =>
    <th key={i+c}>{c}</th>)}
  </tr>
    );
    
  }